import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from "react-router-dom"

// ------ Styles ------ //
import styles from './KioskPrint.module.css'

const KioskPrint = ({
    user,
}) => {
   
    // useLocation & useNavigate --- Client state from previous page
    const navigate = useNavigate()
    const location = useLocation()
    const [styleForm, setStyleForm] = useState(location.state ? location.state.stylingForm : {}) 
    const [kioskSetting, setkioskSetting] = useState(location.state ? location.state.kioskSetting : {}) 
    useEffect(() => {
        // redirect based on configuration
        if (kioskSetting && kioskSetting.useScannerPage !== undefined && kioskSetting.useScannerPage === true && kioskSetting.clientEventLandingPageSetup &&
            kioskSetting.clientEventLandingPageSetup.active !== undefined && kioskSetting.clientEventLandingPageSetup.active === true) {
            navigate('/Kiosk/Scanner')
        }
        else if (kioskSetting && kioskSetting.useLandingPage !== undefined && kioskSetting.useLandingPage === true && kioskSetting.clientEventScannerPageSetup &&
            kioskSetting.clientEventScannerPageSetup.active !== undefined && kioskSetting.clientEventScannerPageSetup.active === true) {
            navigate('/Kiosk/Landing')
        }
        else {
            navigate('/Kiosk/Index')
        }

    }, [])
    
    return (
        <div className={styles.printKioskPage}>
            <h1>
                Printing badge for {styleForm ? styleForm.firstName + ' ' + styleForm.lastName :null}...
            </h1>
        </div>
    );
}

export default KioskPrint;